import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ListItem, Tooltip, Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, Select, MenuItem } from '@material-ui/core';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BuildIcon from '@material-ui/icons/Build';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import LocalBarIcon from '@material-ui/icons/LocalBar';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import PostAddIcon from '@material-ui/icons/PostAdd';
import SettingsIcon from '@material-ui/icons/Settings';
import { IoLocationSharp } from 'react-icons/io5';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ROL_USER } from '../../../app/api-client/constants';
import { getlistUbicacionesUsers, updatelocation } from '../../domain/api/UbicacionesApi';
import { useDispatch } from 'react-redux';
import { Store } from 'react-notifications-component';


const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    title: {
        fontSize: '20px',
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    actionsStyles: {
        padding: 0,
        margin: 0
    },
    tableAction: {
        paddingLeft: 0,
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    tableCell: {
        padding: '8px',
        width: '20%',
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '40%',
        justifyContent: 'space-between',
    },
    iconItem: {
        cursor: 'pointer',
    },
    smallIcon: {
        fontSize: '20px',
        color: '#3E4142',
        marginLeft: '-1.7%'
    },

    paper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '1rem',
        marginBottom: '8px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    nameText: {
        fontFamily: "'Segoe UI Variable Static Display 300', sans-serif",
        fontWeight: 600,
    },
    ubicacionText: {
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',

    },
    ubicacionIcon: {
        color: '#0088FE',
        marginLeft: '20%',
        fontSize: '150%',
        marginTop: '10px'
    },

}));

export const ListBasculas = ({ rows, handleClose, handledViewImc, handledViewUsers, handledViewAcolimetria, handledViewPolls, handledEditSettings, handleSupervisor }) => {
    const classes = useStyles();
    const [openModal, setOpenModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedName, setSelectedName] = useState('');

    const [idEvbi, setIdEvbi] = useState('');
    const [locationOptions, setLocationOptions] = useState([]);
    const [loadingOptions, setLoadingOptions] = useState(true);
    const [, setIsLocationAvailable] = useState(true);
    const [tipoModulo, setTipoModulo] = useState([]);
    const dispatch = useDispatch();

    const history = useHistory();
    const rol = localStorage.getItem(ROL_USER);
    const theme = useTheme();

    useEffect(() => {
        var tipoModuloArray = [];

        var numeroPerguntas = rows.length;
        for (var i = 0; i < numeroPerguntas; i++) {

            const tipoModulosForRow = rows[i].modulos.map((modulo) => modulo.tipoModulo);
            tipoModuloArray.push(tipoModulosForRow);
        }

        setTipoModulo(tipoModuloArray);

    }, [rows]);


    const primaryColor = theme.palette.primary.main;
    // Función para determinar el color del círculo según el estado de los módulos
    const obtenerColorCirculoPorModulos = (modulos) => {
        const tieneModuloActivo = modulos.some(modulo => modulo.estado === 'ACTIVO');
        const tieneModuloInactivo = modulos.some(modulo => modulo.estado === 'INACTIVO');
        return tieneModuloActivo ? 'green' : (tieneModuloInactivo ? 'red' : 'red');
    };

    // Función para determinar el estado según el estado de los módulos
    const obtenerEstadoPorModulos = (modulos) => {
        const tieneModuloInactivo = modulos.some(modulo => modulo.estado === 'INACTIVO');
        const tieneModuloActivo = modulos.some(modulo => modulo.estado === 'ACTIVO');

        if (tieneModuloInactivo) {
            return 'Inactivo';
        } else if (tieneModuloActivo) {
            return 'Activo';
        } else {
            return 'sin modulos';
        }
    };


    // Lógica para cargar las opciones de ubicación desde el API
    const fetchLocationOptions = async (id) => {
        setLoadingOptions(true);



        try {
            const fetchedOptions = await getlistUbicacionesUsers(dispatch, id, "", 0, 30);
            setLocationOptions(fetchedOptions.content)
            setLoadingOptions(false);

        } catch (error) {
            if (error.name === 'AbortError') {

            } else {
                console.error('Error fetching location options:', error);
            }
        } finally {

            setLoadingOptions(false);
        }
    };
    const handleUpdateLocation = async (id) => {

        try {

            const update = await updatelocation(dispatch, idEvbi, selectedLocation);
            if (update) {
                handledAlert("Actualizado Exitosamente!", `Ubicacion actualizada Exitosamente!`, "success")
                setLoadingOptions(false);  // Set loading state to true
                handleCloseModal()
            } else {
                handledAlert("Ocurrio un erro!", "Ocurrio un error al actualizar la ubicacion", "danger")
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');  // Ignore aborted requests
            } else {
                console.error('Error fetching location options:', error);
            }
        } finally {
            // Marca la carga como completa
            setLoadingOptions(false);
        }
    };


    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });

    }

    const handleOpenModal = (locationname, locationid, idEvbi) => {
        setSelectedName(locationname);
        fetchLocationOptions(locationid)
        setIdEvbi(idEvbi)
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };


    return (
        <>
            {rows.map((row, index) => (

                <Paper key={index} className={classes.paper}>
                    <div className={classes.tableCell}>
                        <Typography variant="h5" className={classes.nameText} color='primary'>
                            {row.name}
                        </Typography>
                    </div>
                    <div className={classes.tableCell}>
                        <div className={classes.box}>
                            <IoLocationSharp className={classes.ubicacionIcon} style={{ color: theme.palette.primary.main }} />
                            <div
                                className={classes.tableCell}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleOpenModal(row.ubicacion.value, row.cliente, row.id)}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body1" style={{ marginLeft: '10%', fontWeight: 'bold' }}>
                                        {row.ubicacion.value}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.tableCell}>
                        <div style={{ display: "flex", alignItems: "center", cursor: 'pointer' }} onClick={() => {
                            history.push({
                                pathname: `/basculas/modulos/${row.id}`,
                                state: {
                                    nameBascula: row.name,
                                    ultimaConexion: row.ubicacion.value,
                                    key: row.key
                                },
                            });
                        }}
                        >
                            <div
                                style={{
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '50%',
                                    backgroundColor: obtenerColorCirculoPorModulos(row.modulos),
                                    marginRight: '10px',
                                }}
                            ></div>
                            <Typography button variant="body1" style={{ fontWeight: 'bold' }}>
                                {obtenerEstadoPorModulos(row.modulos)}
                            </Typography>
                        </div>
                    </div>

                    {rol === 'ROLE_SUPPORT' &&
                        <div className={classes.iconContainer} style={{ justifyContent: 'space-evenly' }}>
                            <ListItem className={classes.iconItem} style={{ width: '11%' }} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/mantenimiento/${row.id}`,
                                    state: {
                                        nameBascula: row.name,
                                        ultimaConexion: row.ubicacion.value,
                                        key: row.key
                                    },
                                });
                            }}>
                                <Tooltip title="Mantenimiento" aria-label="top-end">
                                    <BuildIcon className={classes.smallIcon} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} style={{ width: '11%' }} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/documentos/${row.id}`,
                                    state: { documentoId: row.name }
                                });
                            }}>
                                <Tooltip title="Documento" aria-label="top-end">
                                    <AssignmentIndIcon className={classes.smallIcon} />
                                </Tooltip>
                            </ListItem>
                        </div>
                    }
                    {rol === 'ROLE_ADMIN' &&
                        <div className={classes.iconContainer}>
                            <ListItem
                                className={classes.iconItem}
                                button
                                onClick={() => {
                                    handledViewImc(row.id);
                                    history.push({
                                        pathname: `/basculas/mediciones/${row.id}`,
                                        state: {
                                            nameBascula: row.name
                                        },
                                    });
                                }}
                                disabled={tipoModulo[index]?.every(modulo => modulo.modulo === 'ALCOHOLIMETRIA')}
                            >
                                <Tooltip title="Ver Información" aria-label="top-end">
                                    <PostAddIcon
                                        className={classes.smallIcon}
                                        style={{ color: primaryColor }}
                                    />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => { handledViewUsers(row.id, row.name) }}>
                                <Tooltip title="Usuarios" aria-label="top-end">
                                    <PeopleAltIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem
                                className={classes.iconItem}
                                button
                                onClick={() => {
                                    handledViewAcolimetria(row.id, row.name);
                                }}
                                disabled={!tipoModulo[index]?.some(modulo => modulo.modulo === 'ALCOHOLIMETRIA')}
                            >
                                <Tooltip title="Alcoholimetría" aria-label="top-end">
                                    <LocalBarIcon
                                        className={classes.smallIcon}
                                        style={{ color: primaryColor }}
                                    />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                handleSupervisor(row);
                            }}>
                                <Tooltip title="Supervisores" aria-label="top-end">
                                    <SupervisedUserCircleIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/registro`,
                                    state: {
                                        nameBascula: row.name,
                                        ultimaConexion: row.ubicacion.value,
                                        id: row.id,
                                        key: row.key
                                    },
                                });
                            }}>
                                <Tooltip title="Registro de Usuarios" aria-label="top-end">
                                    <HowToRegIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                handledEditSettings(row);
                                handleClose();
                            }}>
                                <Tooltip title="Configuración" aria-label="top-end">
                                    <SettingsIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/documentos/${row.id}`,
                                    state: { documentoId: row.name }
                                });
                            }}>
                                <Tooltip title="Documento" aria-label="top-end">
                                    <AssignmentIndIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/mantenimiento/${row.id}`,
                                    state: {
                                        nameBascula: row.name,
                                        ultimaConexion: row.ubicacion.value,
                                        key: row.key
                                    },
                                });
                            }}>
                                <Tooltip title="Mantenimiento" aria-label="top-end">
                                    <BuildIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                        </div>


                    }
                    {(rol !== 'ROLE_ADMIN' && rol !== 'ROLE_SUPPORT' ) && (
                        <div className={classes.iconContainer}>


                            <ListItem className={classes.iconItem} button onClick={() => {
                                handledViewImc(row.id);
                                history.push({
                                    pathname: `/basculas/mediciones/${row.id}`,
                                    state: {
                                        nameBascula: row.name
                                    },
                                });
                            }}>
                                <Tooltip title="Ver Información" aria-label="top-end">
                                    <PostAddIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => { handledViewUsers(row.id, row.name) }}>
                                <Tooltip title="Usuarios" aria-label="top-end">
                                    <PeopleAltIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => { handledViewAcolimetria(row.id, row.name) }}disabled={!tipoModulo[index]?.some(modulo => modulo.modulo === 'ALCOHOLIMETRIA')}>
                                <Tooltip title="Alcoholímetria" aria-label="top-end">
                                    <LocalBarIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                handleSupervisor(row);
                            }}>
                                <Tooltip title="Supervisores" aria-label="top-end">
                                    <SupervisedUserCircleIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            { rol !=='ROLE_USER' &&
                             <ListItem className={classes.iconItem} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/registro`,
                                    state: {
                                        nameBascula: row.name,
                                        ultimaConexion: row.ubicacion.value,
                                        id: row.id,
                                        key: row.key
                                    },
                                });
                            }}>
                                <Tooltip title="Registro de Usuarios" aria-label="top-end">
                                    <HowToRegIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            }
                          
                            <ListItem className={classes.iconItem} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/documentos/${row.id}`,
                                    state: { documentoId: row.name }
                                });
                            }}>
                                <Tooltip title="Documento" aria-label="top-end">
                                    <AssignmentIndIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                            <ListItem className={classes.iconItem} button onClick={() => {
                                history.push({
                                    pathname: `/basculas/mantenimiento/${row.id}`,
                                    state: {
                                        nameBascula: row.name,
                                        ultimaConexion: row.ubicacion.value,
                                        key: row.key
                                    },
                                });
                            }}>
                                <Tooltip title="Mantenimiento" aria-label="top-end">
                                    <BuildIcon className={classes.smallIcon} style={{ color: primaryColor }} />
                                </Tooltip>
                            </ListItem>
                        </div>
                    )}
                </Paper>
            ))}
            <Dialog open={openModal} onClose={handleCloseModal}>
                <DialogTitle
                    id="customized-dialog-title"
                    className={classes.title}
                    style={{ borderBottom: '1px solid #ccc' }}
                >
                    Editar Ubicacion
                </DialogTitle>
                <DialogContent style={{ padding: '80px' }}>
                    <Typography variant="body1" color="primary" style={{ fontWeight: 'bold', marginBottom: '25px' }}>
                        Ubicación Actual: <span style={{ color: 'black' }}>{selectedName}</span>
                    </Typography>
                    <Typography variant="body1" color="primary" style={{ fontWeight: 'bold' }}>
                        Nueva Ubicación:
                    </Typography>
                    {/* Mostrar un spinner de carga mientras se cargan las opciones */}
                    {loadingOptions ? (
                        <div>Loading...</div>
                    ) : (
                        <Select
                            value={selectedLocation}
                            onChange={(e) => setSelectedLocation(e.target.value)}
                            fullWidth
                            margin="normal"
                        >
                            {locationOptions.length === 0 && (
                                <MenuItem value="" disabled>
                                    No hay ubicaciones disponibles
                                </MenuItem>
                            )}
                            {locationOptions.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.value}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </DialogContent>

                <DialogActions style={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
                    <Button onClick={handleCloseModal} style={{ backgroundColor: primaryColor, color: 'white', borderRadius: '10px', width: '48%' }}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            handleUpdateLocation();
                        }}
                        style={{ backgroundColor: primaryColor, color: 'white', borderRadius: '10px', width: '48%' }}
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    );
};
